<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/Details/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>